const stripeKey = process.env.REACT_APP_PAYMENT_KEY;

if (!stripeKey) {
  throw new Error(
    "REACT_APP_PAYMENT_KEY is not set. Copy frontend_2/.env.example to .env and use your Stripe test publishable key (pk_test_...)."
  );
}

export default stripeKey;
